import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-media-facebook",
  "use": "social-media-facebook-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"social-media-facebook\"><path d=\"M169.57 0h-140a30.09 30.09 0 00-30 30v140a30.09 30.09 0 0030 30h140a30.09 30.09 0 0030-30V30a30.09 30.09 0 00-30-30zm-52 64.27h-8.21q-6.49-.21-6.21 6.14v9.79h14.41v11.36h-14.4V154H88.81V91.56h-7.24V80.2h7.25v-9.74q0-10.52 5.64-15.49 5.5-4.62 13.83-4.62h9.29z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol